module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Book.a7d62c27.eot";